"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mai = void 0;
exports.mai = {
    chef: '0x7754b08aB3b73021736985e90163aCC68484F54A',
};
